import React, { useEffect } from "react";
import { useState } from "react";
import "./CustomAlert.css";
import ApplicationForm from "../images/ApplicationForm.pdf";

const CustomAlert = () => {
  const [isOpenAlert, setIsOpenAlert] = useState(false);

  useEffect(() => {
    setIsOpenAlert(true);
  }, []);

  return (
    <div className={isOpenAlert ? "alert-open " : "close-open"} id="alert-box">
      <p
        onClick={() => {
          setIsOpenAlert(!isOpenAlert);
        }}
        className="close-box"
      >
        <i class="fa-regular fa-circle-xmark"></i>
      </p>
      <div className="alert-details">
        <h2 className="first-heading">राधे-राधे, जय श्री कृष्ण</h2>
        <h3 className="second-heading">শারদীয়ার প্রীতি ও শুভেচ্ছা</h3>
        <h4 className="third-heading">Welcome</h4>
        <h1 className="fourth-heading">GYCTC</h1>
        <p className="links">
          <a href={ApplicationForm} download={"Application Form"}>
            Download Application Form
          </a>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
            target="_blank"
          >
            Online Form Fill Up
          </a>
        </p>
      </div>
    </div>
  );
};

export default CustomAlert;
